import { cn } from '@/utils/cn'
import { type InputHTMLAttributes, forwardRef } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const inputDecorationStyles = cn(
  'rounded-xl border bg-input px-3 py-2 outline-none transition-colors',
  'hocus:bg-input-hover hover:border-body-foreground',
  'focus-visible:border-focus focus-visible:ring-2',
  'disabled:cursor-not-allowed disabled:bg-input-disabled disabled:text-disabled-foreground',
  'disabled:hocus:border-border disabled:hocus:bg-input-disabled'
)

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, autoComplete = 'off', ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'h-10 w-full',
          'text-active-foreground',
          'placeholder:text-placeholder-foreground placeholder:text-sm',
          'disabled:placeholder:text-disabled-foreground',
          inputDecorationStyles,
          className
        )}
        ref={ref}
        autoComplete={autoComplete}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'
